export const SnDocumentType = {
    SSID: 23,// 18,
    docManagementSerialSSID: 18,// 18,
    Card: 22 ,// 6,
    docManagementSerialCard: 6 ,// 6,
    SpecialtyImage:1, // 9,
    docManagementSerialSpecialtyImage:9, // 9,
    ConvertLetter: 29,//7,
    docManagementSerialConvertLetter: 7,//7,
    DoctorSignature: 37,//10,
    ItemImages: 38,//10,
    docManagementSerialDoctorSignature: 10,//10,
    PersonnalImages: 11,//4,
    docManagementSerialPersonnalImages: 4,//4,
    EmployeeImage: 35, //5,
    docManagementSerialEmployeeImage: 5, //5,
}
